import { ShieldX } from "lucide-react";
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "rsuite";

const Unauthorized = () => {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center bg-background px-4">
      <div className="text-center max-w-md">
        <div className="mb-8 flex justify-center">
          <div className="rounded-full bg-destructive/10 p-6">
            <ShieldX className="h-16 w-16 text-destructive" />
          </div>
        </div>

        <h1 className="mb-2 text-7xl font-bold text-foreground">403</h1>
        <h2 className="mb-4 text-2xl font-semibold text-foreground">
          Access Denied
        </h2>
        <p className="mb-8 text-muted-foreground">
          You don't have permission to access this resource. Please contact your
          administrator if you believe this is a mistake.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button onClick={() => navigate(-2)}>Go Back</Button>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
